import React from "react";
import useStyles from "./styles";
import { Typography, Container } from "@material-ui/core";

const NegativeBalanceMessage = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Typography align="center" className={classes.text}>
        This pay period had a negative balance.
      </Typography>
    </Container>
  );
};

export default NegativeBalanceMessage;
